module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACYSURBVHgBvZHNDYMwDEY/B3pnBDZpRmAEVukk7QYdwbkUjpGqtteO0VMT/iSQEAJiBE9KJMvWsy0De2HK95VLmy7VqZlcDnfS2CBYxTECfrzy5okFIGhSdJYLZugFXDyz+nRfBDJM4FVS/ykCCV6BrU24+GRiAX6RJvJ3uaBbFXLBiHhQRQb43/pGzl2gYtMGBOPhJ+s2UwFj5ikPrWHiqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/left-menu-6.png
// module id = 2599
// module chunks = 0